import { List, ListItem } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

export const ReportTypeListItemSkeleton = () => {
  return (
    <ListItem disableGutters>
      <Skeleton variant='rect' width='100%' height='80px' style={{ borderRadius: '8px' }} />
    </ListItem>
  );
};

export const ReportTypeListSkeleton = () => {
  return (
    <List>
      {Array.from(Array(4)).map(() => (
        <ReportTypeListItemSkeleton key={uuidv4()} />
      ))}
    </List>
  );
};
